"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TeamMemberLinkList;
var _react = _interopRequireDefault(require("react"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _components = require("@bluefin/components");
var _ = require("../..");
var _utils = require("../../utils");
/* eslint-disable react/prop-types */

function TeamMemberLinkList(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    teamMembers = _ref.teamMembers,
    allTeamMembers = _ref.allTeamMembers;
  if ((0, _isEmpty2["default"])(teamMembers)) {
    return null;
  }
  var finalClassName = "team-members".concat(className ? " ".concat(className) : '');
  var teamMemberLinks = teamMembers.map(function (teamMember) {
    var teamMemberId = teamMember._id,
      teamMemberName = teamMember.name;
    return /*#__PURE__*/_react["default"].createElement(_components.InternalLink, {
      key: teamMemberId,
      to: (0, _.createTeamMemberSlug)(teamMember, allTeamMembers),
      event: {
        category: _components.EVENT_CATEGORIES.TEAM_EVENT_CATEGORY,
        action: _components.EVENT_ACTIONS.TEAM_VIEW_MEMBER_EVENT_ACTION,
        label: teamMemberName
      }
    }, teamMemberName);
  });
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: finalClassName
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Service offered by:"), " ", (0, _utils.createCommaSeparatedList)(teamMemberLinks), ".");
}